import { normalizeRicosDocument } from '@wix/ricos/internal';
import type { EditorPluginName } from '@wix/ricos/schema-next';

export const fixDocument = async (content: object, plugins: EditorPluginName[]) => {
  const response = await fetch(
    `https://apps.wix.com/_serverless/ricos-playground-services/fix-document`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ content, enabledPlugins: plugins }),
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const result = (await response.json()) as {
    content: object;
    fixed: boolean;
    appliedFixes: [];
  };
  return normalizeRicosDocument(result.content as any);
};
